import React from 'react';
import { Card, CardContent, Typography, Box, Avatar, useTheme } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const StatCard = ({ 
  title, 
  value, 
  icon, 
  color, 
  bgColor, 
  trend, 
  trendIcon, 
  onClick 
}) => {
  const theme = useTheme();

  return (
    <Card 
      onClick={onClick}
      sx={{ 
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.3s ease',
        borderTop: 3,
        borderColor: color,
        '&:hover': onClick ? { 
          boxShadow: theme.shadows[8],
          transform: 'translateY(-4px)',
        } : {},
        height: '100%',
      }}
    >
      <CardContent sx={{ p: 2.5, pb: '16px !important' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box>
            <Typography 
              variant="caption" 
              color="text.secondary" 
              fontWeight={500}
              sx={{ textTransform: 'uppercase', letterSpacing: '0.5px' }}
            >
              {title}
            </Typography>
            <Typography 
              variant="h4" 
              fontWeight={700} 
              sx={{ 
                mt: 0.5,
                fontSize: '1.75rem',
                background: `linear-gradient(135deg, ${color}, ${color}dd)`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {value}
            </Typography>
          </Box>
          <Avatar 
            sx={{ 
              bgcolor: bgColor, 
              color: color,
              width: 48,
              height: 48,
              transition: 'all 0.3s ease',
            }}
          >
            {icon}
          </Avatar>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatCard;